module.exports = __webpack_public_path__ + "img/bannedcustomer_icon.1731ed0d.svg";